import { httpGet } from "shared/api/apiHandler";
import urls from "shared/api/notificationService/urls";
import { NotificationSettings } from "shared/interfaces/notificationSettings";

export const getNotificationSettings = async (): Promise<NotificationSettings> => {
    const result = await httpGet<NotificationSettings>(
        window.APP_SETTINGS.notificationServiceApiBaseUri,
        urls.SETTINGS.SETTINGS_SYSTEM
    );
    return result.data;
};
